import React, { useEffect, useState } from "react";
import "../launch.css";
import AnimatedDigit from "./animatecountdown";

const LAUNCH_TIME = new Date("June 20, 2025 13:30:00").getTime();

function LaunchTimer({ children }) {
  const [timeLeft, setTimeLeft] = useState(LAUNCH_TIME - Date.now());
  const [showOverlay, setShowOverlay] = useState(true);
  const [launched, setLaunched] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  function runCelebrationConfetti() {
    const duration = 5 * 1000;
    const interval = setInterval(() => {
      if (window.confetti) {
        window.confetti({
          particleCount: 100,
          angle: 60 + Math.random() * 60,
          spread: 120 + Math.random() * 60,
          origin: { x: Math.random(), y: Math.random() },
          shapes: ["circle", "square", "star"],
          drift: Math.random() * 2 - 1,
          decay: 0.8,
        });
      }
    }, 100);
    setTimeout(() => clearInterval(interval), duration);
  }
  useEffect(() => {
    const alreadyLaunched = localStorage.getItem("kns_launched");
    if (alreadyLaunched === "true") {
      setShowOverlay(false);
      return;
    }

    const interval = setInterval(() => {
      try {
        const now = Date.now();
        const diff = LAUNCH_TIME - now;
        const min = String(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, "0");
        const remaining = Math.floor((diff % (1000 * 60)) / 1000);

        if (now >= LAUNCH_TIME) {
          console.log("🚀 Launch time has already passed!");
          clearInterval(interval); 
          setLaunched(true);
          setTimeLeft(0);
          if (typeof window.confetti === "function") {
            runCelebrationConfetti(); // your celebration function
          }
        
          localStorage.setItem("kns_launched", "true");
        
          setTimeout(() => setFadeOut(true), 1000);
          setTimeout(() => setShowOverlay(false), 2500);
        }
      if (min === "00" && remaining <= 0) {
          clearInterval(interval);
          setLaunched(true);
          setTimeLeft(0);
          
          if (typeof window.confetti === 'function') {
            runCelebrationConfetti();
          } else {
            console.warn("[CONFETTI] Confetti function not available");
          }

          localStorage.setItem("kns_launched", "true");

          setTimeout(() => {
            setFadeOut(true);
          }, 1000);

          setTimeout(() => {
            setShowOverlay(false);
          }, 2500);
        } else {
          setTimeLeft(diff);
        }
      } catch (error) {
        console.error("[ERROR] Timer error:", error);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  if (!showOverlay) return children;
  const days = String(Math.floor(timeLeft / (1000 * 60 * 60 * 24))).padStart(2, "0");
  const hours = String(Math.floor((timeLeft / (1000 * 60 * 60)) % 24)).padStart(2, "0");
  const minutes = String(Math.floor((timeLeft / 1000 / 60) % 60)).padStart(2, "0");
  const seconds = String(Math.floor((timeLeft / 1000) % 60)).padStart(2, "0");


  return (
    <div className={`launch-overlay bg-class ${fadeOut ? "fade-out" : ""}`}>
      <div className="launch-grid" /> {/* 🔁 Floating grid layer */}
  
      {launched ? (
        <h1 className="launch-title">KNS Logistics Launched! 🎉</h1>
      ) : (
        <>
          <div className="launch-title">KNS Logistics Launching Soon</div>
          <div className="timer-text">Launching in</div>
          <div className="countdown">
            <div className="countdown-box">
            <AnimatedDigit value={days[0]} />
              <AnimatedDigit value={days[1]} />
              <span>:</span>
              <AnimatedDigit value={hours[0]} />
              <AnimatedDigit value={hours[1]} />
              <span>:</span>
              <AnimatedDigit value={minutes[0]} />
              <AnimatedDigit value={minutes[1]} />
              <span>:</span>
              <AnimatedDigit value={seconds[0]} />
              <AnimatedDigit value={seconds[1]} />
            </div>
          </div>
        </>
      )}
    </div>
  );  
}

export default LaunchTimer;
